// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { reduxForm, change, getFormValues } from 'redux-form';
import { Badge, Link, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { ExternalMinor } from '@shopify/polaris-icons';

// import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import * as AppIntegrationActions from 'actions/app-integration-actions';
import { getAssetURL } from 'src/helpers';
import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';
import ModalAppKey from './modal-app-key';
import { AppName } from 'src/constants/integration';

type Props = {
  index: number,
  icon: number,
  name: number,
  appListingURL: string,
  description: string,
  instructionURL: string
};

type ComposedProps = Props & WithI18nProps;

type State = {
  activeModal: boolean,
  hasKey: boolean
};

class StampedioCard extends Component<ComposedProps, State> {
  state = {
    activeModal: false,
    hasKey: false
  };

  componentDidMount() {
    const { stampedAppKey } = this.props;

    if (stampedAppKey) {
      this.setState({ hasKey: true });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { stampedAppKey, switchAppSuccess } = this.props;
    const {
      stampedAppKey: nextStampedAppKey,
      switchAppSuccess: nextSwitchAppSuccess,
      switchAppName: nextSwitchAppName
    } = nextProps;

    // Hide if there are another active app integration
    if (stampedAppKey && !nextStampedAppKey) {
      this.setState({ hasKey: false });
    }

    if (!switchAppSuccess && nextSwitchAppSuccess && nextSwitchAppName === AppName.STAMPED) {
      this.setState({ hasKey: true });
    }
  }

  render() {
    const {
      i18n,
      data = {},
      index,
      handleSubmit,
      pristine,
      themeSetupV2,
      themeSetupV3,
    } = this.props;
    const { hasKey, activeModal } = this.state;
    const {
      icon,
      name,
      // integration,
      appListingURL,
      description,
      instructionURL,
      isFeaturingPartner
    } = data;

    const isHasKey = (themeSetupV2 || themeSetupV3) && hasKey;

    return (
      <div className={index === 1 ? 'item middle' : 'item'}>
        <div className="item-header">
          <a
            className="Polaris-Link"
            href={appListingURL}
            target="_blank"
            rel="noopener noreferrer">
            <img className="icon" src={icon} alt={i18n.translate(name)} />
          </a>
          {isFeaturingPartner && (
            <div className="integration integration--partner">
              <Badge status="info">
                <img
                  className="IconChecked"
                  src={getAssetURL(ADMIN_APP_ASSET_PATHS?.common?.iconCheckPink)}
                  alt="IconChecked"
                  width={14}
                  height={14}
                />

                {i18n.translate('AdminHTML.Integration.Integration.featuringPartner')}
              </Badge>
            </div>
          )}
        </div>

        <div
          className={classNames('third-party-info', { clickable: isHasKey })}
          onClick={() => {
            if (isHasKey) {
              this.setState({ activeModal: true });
            }
          }}>
          {/* App name */}
          <p className="name">{i18n.translate(name)}</p>

          {/* App description */}
          <p className="description">{i18n.translate(description)}</p>
        </div>

        {/*Enable/Disable app key*/}
        {(themeSetupV2 || themeSetupV3) && (
          <div className="BC-Checkbox-Status__Wrapper">
            {/* Integration type */}
            {/* {(themeSetupV2 || themeSetupV3) && integration && (
              <div className="integration">
                <Badge status="info">{i18n.translate(integration)}</Badge>
              </div>
            )} */}

            <div className="integration">
              <Badge status="info">
                <Link url={instructionURL} external>
                  {i18n.translate('AdminHTML.Integration.Constants.integrationGuide')}
                  <Icon source={ExternalMinor} />
                </Link>
              </Badge>
            </div>

            <label className="BC-Checkbox-Status">
              <input type="checkbox" checked={hasKey} onChange={this.handleChange} />
              <span />
            </label>
          </div>
        )}

        {/* Input app key */}
        {/* {(themeSetupV2 || themeSetupV3) && hasKey ? (
          <form onSubmit={this.handleDefaultSubmit}>
            <FormLayout>
              <Field
                name="stampedAppKey"
                component={RenderTextField}
                label={i18n.translate('AdminHTML.Integration.Integration.appKeyPublic')}
                placeholder={i18n.translate(
                  'AdminHTML.Integration.Integration.appKeyPublic_Placholder'
                )}
                tooltip={i18n.translate('AdminHTML.Integration.Integration.appKeyPublic_Tooltip')}
              />
            </FormLayout>
          </form>
        ) : (
          ''
        )} */}

        {/* App instruction */}
        {/* <div className="instruction">
          {i18n.translate('AdminHTML.Integration.Integration.instruction', {
            t: (
              <Link external url={instructionURL}>
                {i18n.translate('AdminHTML.Integration.Integration.instruction_t', {
                  nt_name: i18n.translate(name)
                })}
              </Link>
            )
          })}
        </div> */}

        {/* Submit button */}
        {/* {(themeSetupV2 || themeSetupV3) && hasKey ? (
          <div className="btn-submit">
            <Button primary onClick={handleSubmit(this.handleSave.bind(this))} disabled={pristine}>
              {i18n.translate('AdminHTML.Common.Action.submit')}
            </Button>
          </div>
        ) : (
          ''
        )} */}

        <ModalAppKey
          pristine={pristine}
          title={i18n.translate('AdminHTML.Integration.Integration.stampedIntegration')}
          description={i18n.translate(
            'AdminHTML.Integration.Integration.stampedIntegrationDescription'
          )}
          name="stampedAppKey"
          tooltip={i18n.translate('AdminHTML.Integration.Integration.appKeyPublic_Tooltip')}
          active={activeModal}
          handleCancel={() => {
            this.setState({ activeModal: false });
          }}
          handleConfirm={() => {
            handleSubmit(this.handleSave.bind(this))();
            this.setState({ activeModal: false });
          }}
        />
      </div>
    );
  }

  // Handle default form submit
  handleDefaultSubmit(e) {
    e.preventDefault();
  }

  // Save yotpo app key
  handleSave = data => {
    const {
      data: { appType, appName }
    } = this.props;

    const { stampedAppKey } = data;
    this.props.handleChangeSwitchApp(appType, appName, stampedAppKey);
  };

  // Change status
  handleChange = () => {
    const { hasKey } = this.state;
    const {
      updateField,
      formValues = {},
      currentAppIntegration,
      data: { appType, appName }
    } = this.props;
    const { stampedAppKey } = formValues;

    // Remove app
    if (currentAppIntegration[appType] === appName) {
      this.props.handleChangeRemoveApp(appType, appName);
      return;
    }

    // Delete key if disable app key
    if (hasKey && stampedAppKey) {
      // Clear yotpo app key
      updateField('stampedAppKey', '');
    }

    if (!hasKey) {
      // Open modal to confirm change app
      this.setState({ activeModal: true });
      return;
    }

    this.setState({ hasKey: !hasKey });
  };
}

// Init form values
const buildInitialValues = stampedAppKey => {
  return {
    stampedAppKey
  };
};

const StampedioCardForm = reduxForm({
  form: 'StampedioCardForm', // a unique identifier for this form
  enableReinitialize: true
})(StampedioCard);

const mapDispatchToProps = dispatch => ({
  // Update redux-form field
  updateField: (field, value) => dispatch(change(`StampedioCardForm`, field, value)),
  // Open modal for changing app
  handleChangeSwitchApp: (appType, appName, appKey) =>
    dispatch(AppIntegrationActions.handleChangeSwitchApp(appType, appName, appKey)),
  // Open modal for removing app
  handleChangeRemoveApp: (appType, appName) =>
    dispatch(AppIntegrationActions.handleChangeRemoveApp(appType, appName))
});

const mapStateToProps = state => {
  const stampedAppKey = _.get(state.oauth.tenantApp, 'parseParams.stampedAppKey');
  const currentAppIntegration = _.get(state.oauth.tenantApp, 'currentAppIntegration', {});

  // Show/hide by themeSetupV2
  const themeSetupV2 = _.get(state.oauth, 'tenantApp.adminAppFeatures.themeSetupV2', false);
  const themeSetupV3 = _.get(state.oauth, 'tenantApp.settings.themeSetupV3.settings.enable', false);

  // Get form values
  const formValues = getFormValues('StampedioCardForm')(state);

  return {
    stampedAppKey,
    themeSetupV3,
    currentAppIntegration,
    themeSetupV2,
    initialValues: buildInitialValues(stampedAppKey),
    formValues,
    switchAppSuccess: _.get(state.appIntegration, 'switchAppSuccess', false),
    switchAppName: _.get(state.appIntegration, 'switchAppName', '')
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(StampedioCardForm));
